export default {"src":"/_next/static/media/report.13be00d9.svg","height":213,"width":190,"blurWidth":0,"blurHeight":0};